import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getVerification } from '../../../service/AuthenticationService';

const VerificationPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [token, setToken] = useState(queryParams.get("token"));

  useEffect(() => {
    getVerification(token)

  }, []);

  return (
    <>
      <div className="verification-container" style={{
        backgroundColor: "#f4f4f4",
        height: "100px", marginTop: "200px"
      }}>
        <h2 style={{ color: "#4caf50" }}>Your Account Has Been Verified</h2>
        <p style={{ color: "#333" }}>Thank you for verifying your account. You can now log in and enjoy our services!</p>
      </div>
    </>
  )
}

export default VerificationPage